<style scoped>
	.fade-enter-active, .fade-leave-active {
		transition: opacity 0.15s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}

	.spinner-bg {
		position: fixed;
		top: 0px;
		bottom: 0px;
		left: 0px;
		right: 0px;
		z-index: 100000;
		background-color: rgba(0, 0, 0, 0.75);
	}

	.spinner {
		width: 80px;
		height: 80px;
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -40px;
		margin-right: -40px;
		text-align: center;

		-webkit-animation: sk-rotate 2.0s infinite linear;
		animation: sk-rotate 2.0s infinite linear;
	}

	.dot1, .dot2 {
		width: 60%;
		height: 60%;
		display: inline-block;
		position: absolute;
		top: 0;
		background-color: #40C7F4;
		border-radius: 100%;

		-webkit-animation: sk-bounce 2.0s infinite ease-in-out, color-change 6.0s infinite linear;
		animation: sk-bounce 2.0s infinite ease-in-out, color-change 6.0s infinite linear;
	}

	.dot2 {
		top: auto;
		bottom: 0;
		-webkit-animation-delay: -1.0s;
		animation-delay: -1.0s;
	}

	@-webkit-keyframes color-change {
		33% {
			background-color: #FFDE12;
		}
		66% {
			background-color: #F37121;
		}
		99% {
			background-color: #40C7F4;
		}
	}

	@keyframes color-change {
		33% {
			background-color: #FFDE12;
		}
		66% {
			background-color: #F37121;
		}
		99% {
			background-color: #40C7F4;
		}
	}

	@-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}
	@keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}

	@-webkit-keyframes sk-bounce {
		0%, 100% { -webkit-transform: scale(0.0) }
		50% { -webkit-transform: scale(1.0) }
	}

	@keyframes sk-bounce {
		0%, 100% { 
			transform: scale(0.0);
			-webkit-transform: scale(0.0);
		} 50% { 
			transform: scale(1.0);
			-webkit-transform: scale(1.0);
		}
	}
</style>

<template>
	<transition name="fade">
		<div ref="element" class="spinner-bg animated" v-show="visible">
			<div class="spinner">
				<div class="dot1"></div>
				<div class="dot2"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import { spinner } from '@/hnx/hnx';

export default {
	data() {
		return {
			spinner
		};
	},

	computed: {
		visible() {
			return this.spinner.$spinners.$global.counter > 0;
		}
	}
};
</script>
